import { t } from "@/i18n-js/instance";
import { Modal } from "@/react/components/shared/uikit/ModalV2";

interface HeaderProps {
  hasLocation: boolean;
  onClose: () => void;
}

export const Header = ({ hasLocation, onClose }: HeaderProps) => (
  <Modal.Header>
    <Modal.Title>
      {hasLocation
        ? t("filters.near_me.with_location.title")
        : t("filters.near_me.no_location.title")}
    </Modal.Title>
    <Modal.HeaderActions>
      <Modal.CloseButton onClick={onClose} />
    </Modal.HeaderActions>
  </Modal.Header>
);
